"use client";

var __jsx = React.createElement;
import React from "react";
import { useTranslations } from "next-intl";
import APP_CONFIGURATION from "@lib/app.config";
import { contactSupportNumber, contactEmail, downloadDocType } from "@lib/util/link-redirection-ops";
import { DocumentType } from "types/document-type";
import Icons from "@modules/icons";
import useCssModules from "@lib/hooks/use-css-modules";
const FooterLinks = () => {
  var _cssModules$footers$f;
  const t = useTranslations("Shared.Layout");
  const {
    cssModules
  } = useCssModules();
  const {
    linksContainerClassNames,
    privacyPolicyClassNames,
    termsAndConditionsClassNames,
    phoneNumberClassNames,
    emailClassNames,
    emailIconClassNames,
    phoneNumberIconClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerBancogral) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("div", {
    className: linksContainerClassNames
  }, __jsx("button", {
    onClick: () => {
      downloadDocType(DocumentType.PRIVACY_POLICY);
    },
    className: privacyPolicyClassNames
  }, t("PRIVACY_POLICY")), __jsx("button", {
    onClick: () => {
      downloadDocType(DocumentType.TERMS_AND_CONDITIONS);
    },
    className: termsAndConditionsClassNames
  }, t("TERMS_AND_CONDITIONS")), __jsx("button", {
    className: phoneNumberClassNames,
    onClick: () => contactSupportNumber()
  }, __jsx("div", {
    className: "flex flex-row gap-2 items-center"
  }, __jsx(Icons.telephone, {
    className: phoneNumberIconClassNames
  }), APP_CONFIGURATION.config.contactInformation.phoneNumber)), __jsx("button", {
    className: emailClassNames,
    onClick: () => contactEmail()
  }, __jsx("div", {
    className: "flex flex-row gap-2 items-center"
  }, __jsx(Icons.email, {
    className: emailIconClassNames
  }), APP_CONFIGURATION.config.contactInformation.email)));
};
export default FooterLinks;